export default "__VITE_ASSET__C2RoLW6A__"